import React, { cloneElement, isValidElement, useMemo } from 'react';
import { isFunction } from '@chkp/mwc-common';
import styles from './Bars.scss';

/** resolve bar property into a react element. particular props are passed to the bar for convenience.  */
const useBar = (bar, barData) =>
	useMemo(() => {
		if (bar) {
			if (isValidElement(bar)) {
				const ret = cloneElement(bar, barData);
				return ret;
			}
			if (isFunction(bar)) {
				return bar(barData);
			}
			console.error(
				'DataGrid: bar must be either react element or render function',
			);
		}
		return null;
	}, [bar, barData]);

/**
 * Datagrid toolbars wrapper
 * @returns {JSX.Element}
 */
const Bars = ({
	topBar: topBarProp,
	bottomBar: bottomBarProp,
	contentBar: contentBarProp, //used for messages (e.g. "Loading...")
	leftBar: leftBarProp,
	rightBar: rightBarProp,
	barData,
	children,
}) => {
	const topBar = useBar(topBarProp, barData);
	const bottomBar = useBar(bottomBarProp, barData);
	const contentBar = useBar(contentBarProp, barData);
	const leftBar = useBar(leftBarProp, barData);
	const rightBar = useBar(rightBarProp, barData);

	return (
		<>
			{topBar && <div className={styles.hBar}>{topBar}</div>}
			{leftBar || rightBar ? (
				<div className={styles.hWrap}>
					{leftBar && <div className={styles.vBar}>{leftBar}</div>}
					{children}
					{rightBar && <div className={styles.vBar}>{rightBar}</div>}
				</div>
			) : (
				children
			)}
			{contentBar && <div className={styles.hBar}>{contentBar}</div>}
			{bottomBar && <div className={styles.hBar}>{bottomBar}</div>}
		</>
	);
};

export { Bars };
